import { render, staticRenderFns } from "./DreReport.vue?vue&type=template&id=631c3c08"
import script from "./DreReport.vue?vue&type=script&lang=js"
export * from "./DreReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports